<template>
    <transition name="fade">
        <div :class="{ 'card': true, 'eap': isEap }">
            <div class="card-header">
                <div>
                    <div>
                        <img width="77.486" height="79.259" :src="`/wp-content/themes/bpa-health/dist/images/icons/icon-${type}.svg`">
                    </div>
                    <div class="mid">
                        <h3>{{ data.PROVIDER_FIRST_NAME }} {{ data.Provdier_Last_Name }}</h3>
                        <h4 v-if="data.Licensce_Type && isEap">{{ data.Licensce_Type }}</h4>
                        <span class="text-secondary" v-if="data.ACCEPTING_NEW_PATIENT && isEap">Accepting new patients</span>
                        <span class="text-secondary" v-else-if="!data.ACCEPTING_NEW_PATIENT && isEap">Not Accepting New Patients</span>
                    </div>
                </div>
                <!-- <div class="btn-container">
                    <a :href="data.link ? data.link : data.document" class="btn btn-primary">View More</a>
                </div> -->
            </div>

            <div class="card-body">
                <a href="#" @click.prevent="showInfoContainer" :class="{ 'view-information': true, 'toggle': hideInfo }">
                    <span>View Information </span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="15.123" height="7.773" viewBox="0 0 15.123 7.773" class="close">
                        <path id="Union_8" data-name="Union 8" d="M6.683,7.046,0,14.091ZM0,0,6.67,7.06Z" transform="translate(0.515 7.228) rotate(-90)" fill="#222" stroke="#2c2c2c" stroke-width="1.5"></path>
                    </svg>
                </a>
                <transition name="fade">
                    <div class="info-container" v-show="!isMobile && !hideInfo">
                        <div class="left">
                            <div>
                                <div class="d-flex" v-if="data.Phone">
                                    <div class="icon-container">
                                        <img src="/wp-content/themes/bpa-health/dist/images/icons/icon-phone.svg">
                                    </div>
                                    <div class="info">
                                        <label>Phone</label>
                                        <a href="tel:{{ data.Phone }}">{{ data.Phone }}</a>
                                    </div>
                                </div>

                                <div class="d-flex" v-if="data.Fax">
                                    <div class="icon-container">
                                        <img src="/wp-content/themes/bpa-health/dist/images/icons/icon-fax.svg">
                                    </div>
                                    <div class="info">
                                        <label>Fax</label>
                                        <span>{{ data.Fax }}</span>
                                    </div>
                                </div>

                                <div class="d-flex" v-if="data.Address || data.City || data.State || data.Zip">
                                    <div class="icon-container">
                                        <img src="/wp-content/themes/bpa-health/dist/images/icons/icon-location.svg">
                                    </div>
                                    <div class="info">
                                        <label>Address</label>
                                        <span>{{ data.Address }}</span>
                                        <span>{{ data.City }}, {{ data.State }} {{ data.Zip }}</span>
                                        <span class="distance">Distance: {{ distance }} Miles</span>
                                        <div class="direction">
                                            <Link :label="'Get Directions'" :href="directionLink" :target="'__blank'" />
                                        </div>
                                    </div>
                                </div>

                                <div class="d-flex" v-if="isSUD && hasHours">
                                    <div class="icon-container">
                                        <img src="/wp-content/themes/bpa-health/dist/images/icons/icon-time.svg">
                                    </div>
                                    <div class="info">
                                        <label>Hours</label>
                                        <span v-if="data.MonHours && '---' !== data.MonHours">Mon - Fri: {{ data.MonHours }}</span>
                                        <span v-if="data.SatHours && '---' !== data.SatHours">Saturday: {{ data.SatHours }}</span>
                                        <span v-if="data.SunHours && '---' !== data.SunHours">Sunday: {{ data.SunHours }}</span>
                                    </div>
                                </div>

                                <div class="d-flex" v-if="isEap && data.business_hours">
                                    <div class="icon-container">
                                        <img src="/wp-content/themes/bpa-health/dist/images/icons/icon-time.svg">
                                    </div>
                                    <div class="info">
                                        <label>Hours</label>
                                        <span>{{ data.business_hours }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex m-30 d-center d-bottom">
                                <div class="provider-info">
                                    <Link :label="'Send Provider Information'" :callback="trigerOpenModal" />
                                </div>
                            </div>
                        </div>
                        <div class="right">
                            <ul class="description" v-if="isEap">
                                <li>
                                    <h2>Specialties</h2>

                                    <p>{{ data.Specialties }}</p>
                                </li>
                                <li>
                                    <div class="aged-served" v-if="data.AGE">
                                        <h2>Age(s) Served</h2>
                                        <p>{{ data.AGE }}</p>
                                    </div>
                                </li>
                                <li>
                                    <h2>Provider Gender</h2>

                                    <p>{{ data.Provider_Gender }}</p>
                                </li>
                                <li>
                                    <div v-if="data.Language">
                                        <h2>Language(s)</h2>
                                        <p>{{ data.Language }}</p>
                                    </div>
                                </li>
                            </ul>
                            <ul v-if="isSUD">
                                <li class="mb-24">
                                    <h2>Services</h2>

                                    <div class="adult_container" v-if="data.rss_adult || data.tx_adult">
                                        <h3>Adults</h3>
                                        <p v-if="data.tx_adult" class="mb-10">Treatment: {{ data.tx_adult }}</p>
                                        <p v-if="data.rss_adult">RSS: {{ data.rss_adult }}</p>
                                    </div>

                                    <div class="adolescents_container" v-if="data.rss_adolescent || data.tx_adolescent">
                                        <h3>Adolescents</h3>
                                        <p v-if="data.tx_adolescent" class="mb-10">Treatment: {{ data.tx_adolescent }}</p>
                                        <p v-if="data.rss_adolescent">RSS: {{ data.rss_adolescent }}</p>
                                    </div>
                                </li>
                                <li class="mb-24">
                                    <ul class="additional-services">
                                        <li v-if="data.PopGenderSpecific">Women Only</li>
                                        <li v-if="data.LangInterpreter">Works with Interpreters</li>
                                        <li v-if="data.Offers_TeleHealth">Telehealth</li>
                                    </ul>
                                </li>
                                <li>
                                    <div class="evidence-based-practices-container">
                                        <h2>Evidence-Based Practices</h2>
                                        <p v-if="data.EBP" class="mb-10">{{ data.EBP }}</p>
                                        <p v-else>Contact the provider for a listing of programs offered.</p>
                                    </div>
                                </li>
                                <li>
                                    <div class="aged-served" v-if="data.AGE">
                                        <h2>Age(s) Served</h2>
                                        <p>{{ data.AGE }}</p>
                                    </div>
                                </li>

                                <li>
                                    <div class="languages" v-if="data.Language">
                                        <h2>Language(s)</h2>
                                        <p>{{ data.Language }}</p>
                                    </div>
                                </li>
                                <li>
                                    <div class="funding-source" v-if="data.Funding_Source">
                                        <h2>Funding Source</h2>
                                        <p>{{ data.Funding_Source }}</p>
                                    </div>
                                </li>
                            </ul>

                            <ul v-if="isEap && data.Offers_TeleHealth" class="eap-services">

                                <li>
                                    <ul class="additional-services">
                                        <li v-if="data.Offers_TeleHealth">Telehealth</li>
                                    </ul>
                                </li>
                            </ul>

                            <AuthenticationRequired v-if="isEap" />

                            <div class="updated-date" v-if="data.last_updated">
                                <small>Updated {{ updateDate }}</small>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </transition>
</template>
  
<script>
import Link from '../components/Link.vue'
import moment from 'moment'
import AuthenticationRequired from '../components/AuthenticationRequired.vue'

export default {
    props: {
        data: Object,
        type: {
            required: true,
            type: String
        }
    },
    data () {
        return {
            distance: 0,
            isMobile: false,
            hideInfo: true,
            direction: {
                lat: '',
                lng: ''
            }
        }
    },
    components: { Link, AuthenticationRequired },
    methods: {
        trigerOpenModal () {
            this.$emit( 'openModal', this.data )
        },
        showInfoContainer () {
            this.hideInfo = !this.hideInfo
            this.isMobile = !this.isMobile
        },
        calculateDistance ( lat1, lng1, lat2, lng2 ) {
            const radius = 6371 // Earth's radius in km
            const dLat = this.toRadians( lat2 - lat1 )
            const dLng = this.toRadians( lng2 - lng1 )
            const a = Math.sin( dLat / 2 ) * Math.sin( dLat / 2 ) +
                Math.cos( this.toRadians( lat1 ) ) * Math.cos( this.toRadians( lat2 ) ) *
                Math.sin( dLng / 2 ) * Math.sin( dLng / 2 )
            const c = 2 * Math.atan2( Math.sqrt( a ), Math.sqrt( 1 - a ) )
            const distance = radius * c

            return ( distance * 0.621371 ).toFixed( 2 )
        },

        // Converts numeric degrees to radians
        toRadians ( degree ) {
            return degree * ( Math.PI / 180 )
        },

        checkIfMobile () {
            if ( window.innerWidth <= 1024 ) {
                this.isMobile = true
                this.hideInfo = true
            } else {
                this.isMobile = false
                this.hideInfo = false
            }
        },
    },
    watch: {
        direction: function ( value ) {
            this.distance = this.calculateDistance( this.data.lat, this.data.lng, value.lat, value.lng )
        }
    },
    computed: {
        updateDate () {
            return moment( this.data.last_updated ).format( 'MMMM DD, YYYY' )
        },
        directionLink () {
            return 'https://maps.google.com/maps?daddr=' + encodeURIComponent( `${ this.data.Address } ${ this.data.City } , ${ this.data.State } ${ this.data.Zip }` )
        },
        isEap () {
            return 'eap' === this.type
        },
        isSUD () {
            return 'sud' === this.type
        },
        hasHours () {
            return ( this.data.SunHours && '---' !== this.data.SunHours ) &&
                ( this.data.MonHours && '---' !== this.data.MonHours ) &&
                ( this.data.TueHours && '---' !== this.data.TueHours ) &&
                ( this.data.WedHours && '---' !== this.data.WedHours ) &&
                ( this.data.ThuHours && '---' !== this.data.ThuHours ) &&
                ( this.data.FriHours && '---' !== this.data.FriHours ) &&
                ( this.data.SatHours && '---' !== this.data.SatHours )
        }
    },
    created () {
        const _SELF = this
        _SELF.checkIfMobile()

        if ( navigator.geolocation ) {
            navigator.geolocation.getCurrentPosition( function ( position ) {
                _SELF.direction = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                }
            } )
        } else {
            console.log( "Geolocation is not supported by this browser." )
        }

    },
    mounted () {
        window.addEventListener( "resize", this.checkIfMobile.bind( this ) )
    }
}
</script>

<style lang="scss" scoped>
@import "../../sass/variables";
@import "../../sass/mixins";

.card {
    display: flex;
    flex-direction: column;
    gap: 42px;
    padding: 20px;
    background-color: rgba(240 237 233 / 0.79);
    border-radius: 5px;

    @include md {
        gap: 16px;
    }

    @include sm {
        padding: 16px;
    }

    .card-header {
        display: grid;
        grid-template-columns: 11fr 3fr;
        column-gap: 32px;
        align-items: center;
        padding: 24px;
        background-color: #0B3148;
        border-radius: 5px;

        @include lg {
            grid-template-columns: 1fr;
            gap: 16px;
        }

        &>div {
            display: flex;
            gap: 32px;
            align-items: center;

            a {
                @include md {
                    width: 100%;
                }
            }
        }

        .btn-container {
            @include lg {
                display: none;
            }
        }

        h3 {
            font-family: "Paralucent Demi";
            color: #ffffff;
            font-size: 22px;
            margin-bottom: 0;

            @include md {
                font-size: 18px;
            }
        }
    }

    .card-body {
        padding: 0 16px;
        margin-bottom: 22px;

        @include sm {
            padding: 0;
        }

        p {
            font-size: 14px;
        }

        .mb-10 {
            margin-bottom: 10px;
        }

        .view-information {
            display: none;

            @include lg {
                display: flex;
                align-items: center;
                justify-content: space-between;

                svg {
                    transform: rotate(0);
                }
            }

            &.toggle {
                @include xl {

                    svg {
                        transform: rotate(180deg);
                    }
                }
            }
        }

        .info-container {
            display: grid;
            gap: 50px;
            grid-template-columns: 230px 1fr;

            @include lg {
                margin-top: 40px;
                grid-template-columns: 1fr;
            }

            .left {
                position: relative;
                display: flex;
                flex-direction: column;

                &>div {
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    gap: 28px;

                    @include lg {
                        flex-direction: row;
                        flex-wrap: wrap;
                    }

                }

                .d-flex {
                    flex: 45%;
                    display: flex;
                    gap: 8px;
                    justify-content: flex-start;
                    align-items: flex-start;

                    &.d-center {
                        @include lg {
                            justify-content: center;
                        }
                    }

                    label {
                        display: block;
                        font-weight: bold;
                        font-family: Paralucent;
                        font-style: normal;
                        font-size: 16px;
                        line-height: 1;
                        margin-bottom: 8px;
                    }

                    a,
                    span {
                        display: block;
                        font-weight: 500;
                        font-family: Paralucent;
                        font-style: normal;
                        font-size: 14px;
                        color: #0B3148;
                    }

                    .distance {
                        color: #C7932C;
                        font-weight: 200;
                        font-size: 12px;
                        font-family: Paralucent Extra;
                        font-style: normal;
                        margin: 6px 0;
                    }

                    &.d-bottom {
                        display: flex;
                        justify-content: flex-end;

                        @include lg {
                            justify-content: center;
                        }

                        .provider-info {
                            margin-top: 30px;
                            margin-left: 16px;
                        }
                    }
                }

                &::after {
                    position: absolute;
                    width: 1.3px;
                    height: 100%;
                    background-color: #0B3148;
                    top: 0;
                    right: 0;
                    content: "";

                    @include lg {
                        top: initial;
                        right: initial;
                        bottom: -24px;
                        left: 0;
                        width: 100%;
                        height: 1.3px;
                    }
                }
            }

            .right {
                position: relative;
                display: flex;
                flex-direction: column;
                gap: 16px;

                &>ul {
                    &:not(.eap-services) {
                        column-count: 2;
                        column-gap: 32px;
                        row-gap: 12px;
                    }

                    &.eap-services {
                        margin: 0;

                        li {
                            margin-bottom: 0;
                        }
                    }

                    @include lg {
                        padding: 0;
                    }

                    &.description {
                        @include lg {
                            grid-template-columns: 1fr;
                        }
                    }

                    li {
                        break-inside: avoid-column;
                        margin-bottom: 16px;

                        &.mb-24 {
                            margin-bottom: 24px;
                        }

                        h2 {
                            font-size: 16px;
                            line-height: 2;
                            margin-bottom: 0;
                        }

                        h3 {
                            font-family: "Paralucent Demi";
                            font-size: 14px;
                            font-style: normal;
                            line-height: 1.9;
                            margin-top: 8px;
                            margin-bottom: 2px;
                        }

                        .adolescents_container {
                            margin-top: 10px;
                        }

                        .additional-services {
                            margin-top: 28px;

                            li {
                                position: relative;
                                font-size: 14px;
                                margin-left: 24px;

                                &::before {
                                    position: absolute;
                                    left: -24px;
                                    top: 2px;
                                    width: 12px;
                                    height: 12px;
                                    content: url("/wp-content/themes/bpa-health/dist/images/icons/icon-circle-tick.svg");
                                }
                            }
                        }

                        .evidence-based-practices-container {
                            h2 {
                                margin-bottom: 0;
                            }
                        }

                        .aged-served,
                        .languages,
                        .funding-source {
                            margin-top: 20px;
                        }
                    }
                }

                .updated-date {
                    position: relative;
                    text-align: right;

                    @include lg {
                        text-align: center;
                    }

                    small {
                        color: #C7932C;
                        font-family: "Paralucent Demi";
                        font-size: 12px;
                        font-style: normal;
                        line-height: 1.9;
                    }
                }
            }
        }
    }

    .card-footer {
        color: #C7932C;
        font-size: 12px;
        margin-top: 20px;
    }

    &.eap {
        .card-header {
            .mid {
                display: grid;

                @include md {
                    gap: 8px;
                }

                h3 {
                    margin-bottom: 0;
                }

                h4 {
                    font-size: 16px;
                    color: #ffffff;
                    margin-bottom: 0;

                    @include md {
                        font-size: 14px;
                    }
                }

                span {
                    font-family: "Paralucent Demi";
                    font-size: 16px;
                    color: #C7932C;
                    text-transform: capitalize;
                    margin-top: 24px;

                    @include md {
                        margin-top: 0;
                        font-size: 14px;
                    }
                }
            }
        }
    }
}
</style>